import { collection, query, where, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'certificates';

/**
 * Fetch all certificates for a user.
 */
export async function getCertificatesForUser(userId) {
  if (!userId) return [];
  const q = query(collection(db, COLLECTION), where('userId', '==', userId));
  const snap = await getDocs(q);
  const list = [];
  snap.forEach((docSnap) => {
    const d = docSnap.data();
    list.push({
      id: docSnap.id,
      userId: d.userId,
      courseId: d.courseId,
      courseTitle: d.courseTitle || '',
      userName: d.userName || '',
      completedAt: d.completedAt,
    });
  });
  list.sort((a, b) => {
    const ta = a.completedAt?.toMillis?.() ?? 0;
    const tb = b.completedAt?.toMillis?.() ?? 0;
    return tb - ta;
  });
  return list;
}

/**
 * Create a certificate when user completes a course (100% progress).
 * Idempotent: if one already exists for userId+courseId, skip.
 */
export async function createCertificateIfNeeded(userId, userName, courseId, courseTitle) {
  if (!userId || !courseId) return null;
  const existing = await getCertificatesForUser(userId);
  if (existing.some((c) => String(c.courseId) === String(courseId))) return null;
  const ref = await addDoc(collection(db, COLLECTION), {
    userId,
    courseId,
    courseTitle: courseTitle || '',
    userName: userName || '',
    completedAt: serverTimestamp(),
  });
  return ref.id;
}
